export default "__VITE_ASSET__D$Ck2rYW__"